import React from 'react';
import { Link } from 'react-router-dom';
import PlanExceededLogo from './PlanExceededLogo.svg';
import './PlanExceeded.css';
import { t } from 'i18next';

export default ({ className = 'full', type = 'page' }) => {
  return (
    <div className={`access-denied ${className}`}>
      <img src={PlanExceededLogo} alt="access-denied" />
      <h1>{t('Settings.plan_exceeded')}</h1>
      <h4>
        {t('Settings.plan_limit_exceed')}{' '}
        <span onClick={() => <Link to="packagesplan" />}>
          {t('Settings.upgrade')}
        </span>{' '}
        {t('Settings.to')}
        {t('Settings.continue')}
      </h4>
    </div>
  );
};
